(function () {
  const nav = document.querySelector('ul.mobile-nav');
  if (!nav) return;

  const wrapper = document.createElement('div');
  wrapper.className = 'drilldown-wrapper';

  const mainPanel = document.createElement('div');
  mainPanel.className = 'drilldown-panel drilldown-panel--main drilldown-panel--active';

  Array.from(nav.children).forEach(li => mainPanel.appendChild(li));
  wrapper.appendChild(mainPanel);
  nav.appendChild(wrapper);

  // ── Espaço entre os 3 primeiros itens (DOMŮ, ŽENY, MUŽI)
  const mainItems = Array.from(mainPanel.children).filter(el => el.classList.contains('mobile-nav__item'));
  mainItems.slice(0, 3).forEach(el => {
    el.style.setProperty('margin-bottom', '0px', 'important');
    el.style.setProperty('padding-bottom', '0px', 'important');
  });

  function createBackHeader(title, href) {
    const header = document.createElement('div');
    header.className = 'drilldown-header';
    header.innerHTML = `
      <button class="drilldown-back" type="button">
        <svg width="16" height="16" viewBox="0 0 28 16" fill="none">
          <path d="M27 8H1M1 8L8 1M1 8L8 15" stroke="#000" stroke-width="2"/>
        </svg>
      </button>
      ${href
        ? `<a href="${href}" class="drilldown-header__title">${title}</a>`
        : `<span class="drilldown-header__title">${title}</span>`
      }
    `;
    return header;
  }

  function createArrow() {
    const arrow = document.createElement('span');
    arrow.className = 'drilldown-arrow';
    arrow.innerHTML = `<svg width="8" height="14" viewBox="0 0 8 14" fill="none">
      <path d="M1 1l6 6-6 6" stroke="#000" stroke-width="1.5"/>
    </svg>`;
    return arrow;
  }

  function openPanel(panel, from) {
    from.classList.remove('drilldown-panel--active');
    panel.classList.add('drilldown-panel--active');
  }

  function closePanel(panel, to) {
    panel.classList.remove('drilldown-panel--active');
    to.classList.add('drilldown-panel--active');
  }

  mainPanel.querySelectorAll('.mobile-nav__has-sublist').forEach(item => {
    const labelEl = item.querySelector('.mobile-nav__link--top-level');
    const li = item.closest('li');
    const sublinkDiv = li.querySelector('[id^="Linklist-"]');
    if (!sublinkDiv || !labelEl) return;

    const labelText = labelEl.textContent.trim();
    const labelHref = labelEl.getAttribute('href');

    const toggleDiv = item.querySelector('.mobile-nav__toggle');
    if (toggleDiv) toggleDiv.remove();
    item.appendChild(createArrow());
    item.style.cursor = 'pointer';

    const panel2 = document.createElement('div');
    panel2.className = 'drilldown-panel drilldown-panel--sub';
    const header2 = createBackHeader(labelText, labelHref);
    panel2.appendChild(header2);

    const childItems = sublinkDiv.querySelectorAll('.mobile-nav__item');
    const childUl = document.createElement('ul');
    childUl.className = 'drilldown-list';

    childItems.forEach(childLi => {
      const childItem = childLi.querySelector('.mobile-nav__child-item');
      if (!childItem) return;

      const btn = childItem.querySelector('button.collapsible-trigger');
      const linkEl = childItem.querySelector('a.mobile-nav__link');
      const subId = btn?.getAttribute('aria-controls');
      const subDiv = subId ? document.getElementById(subId) : null;
      const grandchildList = subDiv?.querySelector('.mobile-nav__grandchildlist');

      const childText = btn?.querySelector('.mobile-nav__faux-link')?.textContent.trim()
        || linkEl?.textContent.trim()
        || '';
      const childHref = linkEl?.getAttribute('href') || null;

      const newLi = document.createElement('li');
      newLi.className = 'drilldown-list__item';

      if (grandchildList) {
        const row = document.createElement('div');
        row.className = 'drilldown-list__row';
        row.innerHTML = `<span class="drilldown-list__label">${childText}</span>`;
        row.appendChild(createArrow());
        row.style.cursor = 'pointer';
        newLi.appendChild(row);

        const panel3 = document.createElement('div');
        panel3.className = 'drilldown-panel drilldown-panel--sub';
        const header3 = createBackHeader(childText, childHref);
        panel3.appendChild(header3);

        const grandUl = document.createElement('ul');
        grandUl.className = 'drilldown-list';
        grandchildList.querySelectorAll('a.mobile-nav__link').forEach(a => {
          const gLi = document.createElement('li');
          gLi.className = 'drilldown-list__item';
          gLi.innerHTML = `<a href="${a.getAttribute('href')}" class="drilldown-list__link">${a.textContent.trim()}</a>`;
          grandUl.appendChild(gLi);
        });
        panel3.appendChild(grandUl);
        wrapper.appendChild(panel3);

        row.addEventListener('click', () => openPanel(panel3, panel2));
        panel3.querySelector('.drilldown-back').addEventListener('click', () => closePanel(panel3, panel2));

      } else if (childHref) {
        newLi.innerHTML = `<a href="${childHref}" class="drilldown-list__link">${childText}</a>`;
      }

      childUl.appendChild(newLi);
    });

    panel2.appendChild(childUl);
    wrapper.appendChild(panel2);

    item.addEventListener('click', (e) => {
      e.preventDefault();
      openPanel(panel2, mainPanel);
    });
    header2.querySelector('.drilldown-back').addEventListener('click', () => closePanel(panel2, mainPanel));
  });

  // ── Corrigir largura e setas
  function fixNavWidth() {
    const drawer = document.querySelector('.drawer__scrollable');
    if (!drawer) return;
    const drawerWidth = drawer.offsetWidth;

    wrapper.style.marginLeft = '0px';
    wrapper.style.paddingLeft = '0px';
    wrapper.style.paddingRight = '0px';
    wrapper.style.width = '100%';

    wrapper.querySelectorAll('.mobile-nav__has-sublist').forEach(el => {
      el.style.position = 'relative';
      el.style.width = (drawerWidth + 182) + 'px';
      el.style.marginLeft = '0px';
      el.style.paddingLeft = '20px';
      el.style.paddingRight = '0px';
    });

    wrapper.querySelectorAll('.drilldown-arrow').forEach(el => {
      el.style.position = '';
      el.style.right = '';
    });
    mainPanel.querySelectorAll('.drilldown-arrow').forEach(el => {
      el.style.position = 'absolute';
      el.style.right = '200px';
    });
  }

  fixNavWidth();
  window.addEventListener('resize', fixNavWidth);

  const drawerEl = document.querySelector('.drawer');
  if (drawerEl) {
    const observer = new MutationObserver(fixNavWidth);
    observer.observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
  }

})();
